<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="120px" :rules="rules">
					<el-row>
						<el-col :span="12">
							<el-form-item label="名    称" prop="name"><el-input v-model="formParameter.name" autocomplete="off"></el-input></el-form-item>
						</el-col>
          
						<el-col :span="12">
							<el-form-item label="官    网" prop="url"><el-input v-model="formParameter.url" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="规    模" prop="maxemps">
								 <select-option-dictionary v-model="formParameter.maxemps" dkey="cmpygm"></select-option-dictionary>
								</el-form-item>
						</el-col> 
						<el-col :span="12">
							<el-form-item label="来源类型" prop="source">
								 <select-option-dictionary v-model="formParameter.source" dkey="jycmp-ly"></select-option-dictionary>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="电  话" prop="tel"><el-input v-model="formParameter.tel" autocomplete="off"></el-input></el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系人/电话" prop="mobile"><el-input v-model="formParameter.mobile" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="地址" prop="address"><el-input v-model="formParameter.address" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="描述" prop="descb"><el-input type="textarea"   :rows="3" v-model="formParameter.descb" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="备注" prop="remark"><el-input type="textarea"   :rows="3" v-model="formParameter.remark" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>

import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/interview/company/company.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';

export default {
	name: 'edit',
	components: {
			popup,
			selectOptionDictionary
		},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {source:'2'},
			rules: {
						//名称
						name: [
							{
								validator: this.$validate.required,
								trigger: 'blur'
							}
							 
						]
			}
		};
	},
	methods: {
			//打开弹框
			open(parameter, title, disabled, size) {
				this.parameter = parameter;
				this.disabled = disabled;
				this.$refs.popup.open(title, size);
				this.$nextTick(() => {
					this.init();
				})
			},
			//关闭弹框
			close() {
				this.disabled = false;
				this.$refs.popup.close();
			},
			//提交表单
			confirm() {
				this.$utils.checkForm(this.$refs.form, () => {
					this.confirmLoading = true;
					if (!this.parameter.id) {
						//添加
						let parameter = this.$utils.merger(this.formParameter);
						api.save(parameter,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
					} else {
						//编辑
						let parameter = this.$utils.merger(this.formParameter);
						api.update(parameter,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
					}
				});
			},
			init() {
				this.popupLoading = true;
				//清除等待
				this.confirmLoading = false;
				//清空内容
				this.formParameter = {source:'2'};
				//清楚校验
				this.$refs.form.clearValidate();
				
				if (this.parameter.id) {
					//编辑查询数据
					let parameter = {
						id: this.parameter.id
					};
					api.toUpdate(parameter, response => {
						this.formParameter = response.data;
						this.popupLoading = false;
					});
				} else {
					//添加
					this.popupLoading = false;
				}
			}
		}
	};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
	@import '~common/custom/css/popup/popup.scss';
</style>
